import { ILanguageConfig } from './IConfiguration';
import { Dictionary } from "../common/SharedTypes";

class LanguagesConfiguration implements ILanguageConfig {

    public SupportedLanguages : string[] = [
        "en-US",
        "ar-SA",
        "bg-BG",
        "cs-CZ",
        "da-DK",
        "de-DE",
        "el-GR",
        "es-ES",
        "et-EE",
        "fi-FI",
        "fr-FR",
        "he-IL",
        "hi-IN",
        "hu-HU",
        "id-ID",
        "it-IT",
        "ja-JP",
        "ko-KR",
        "nl-NL",
        "nb-NO",
        "pl-PL",
        "pt-PT",
        "pt-BR",
        "ro-RO",
        "ru-RU",
        "sv-SE",
        "tr-TR",
        "uk-UA",
        "zh-CN",
        "zh-TW"
    ];
    public LanguagesMapping: Dictionary<string> =
    {
        "en": "en-US",
        "ar": "ar-SA",
        "bg": "bg-BG",
        "cs": "cs-CZ",
        "da": "da-DK",
        "de": "de-DE",
        "el": "el-GR",
        "es": "es-ES",
        "et": "et-EE",
        "fi": "fi-FI",
        "fr": "fr-FR",
        "he": "he-IL",
        "hi": "hi-IN",
        "hu": "hu-HU",
        "id": "id-ID",
        "it": "it-IT",
        "ja": "ja-JP",
        "ko": "ko-KR",
        "nl": "nl-NL",
        "no": "nb-NO",
        "pl": "pl-PL",
        "pt": "pt-PT",
        "pt-br": "pt-BR",
        "ro": "ro-RO",
        "ru": "ru-RU",
        "sv": "sv-SE",
        "tr": "tr-TR",
        "uk": "uk-UA",
        "zh-Hans": "zh-CN",
        "zh-Hant": "zh-TW"
    };
}

export const languagesConfiguration = new LanguagesConfiguration();